import * as twitter2fa from './twitter2fa'
import * as twitterAiOptOut from './twitterAiOptOut'
import * as twitterBlockReposters from './twitterBlockReposters'
import * as twitterDeleteAllPosts from './twitterDeleteAllPosts'
import * as twitterDeleteLikes from './twitterDeleteLikes'
import * as twitterDiscoverability from './twitterDiscoverability'
import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './twitterGatherMachine'
import * as twitterDeleteConversations from './twitterLeaveDirectMessages'
import * as twitterLocationProfile from './twitterLocationProfile'
import * as twitterLocationTweets from './twitterLocationTweets'
import * as twitterMutedNotifications from './twitterMutedNotifications'
import { TwitterRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [TwitterRecommendationKey.TWITTER_MUTED_NOTIFICATIONS]:
    twitterMutedNotifications,
  [TwitterRecommendationKey.TWITTER_LOCATION_ACCESS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TwitterRecommendationKey.TWITTER_LOCATION_ACCESS,
      ),
    ],
  },
  [TwitterRecommendationKey.TWITTER_LOCATION_PROFILE]: twitterLocationProfile,
  [TwitterRecommendationKey.TWITTER_LOCATION_TWEETS]: twitterLocationTweets,
  [TwitterRecommendationKey.TWITTER_DISCOVERABILITY]: twitterDiscoverability,
  [TwitterRecommendationKey.TWITTER_2FA]: twitter2fa,
  [TwitterRecommendationKey.TWITTER_CONTACTS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TwitterRecommendationKey.TWITTER_CONTACTS,
      ),
    ],
  },
  [TwitterRecommendationKey.TWITTER_SECURITY]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TwitterRecommendationKey.TWITTER_SECURITY,
      ),
    ],
  },
  [TwitterRecommendationKey.TWITTER_AUDIO_VIDEO_CALLS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TwitterRecommendationKey.TWITTER_AUDIO_VIDEO_CALLS,
      ),
    ],
  },
  [TwitterRecommendationKey.TWITTER_SESSIONS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        TwitterRecommendationKey.TWITTER_SESSIONS,
      ),
    ],
  },
  [TwitterRecommendationKey.TWITTER_DELETE_POSTS_BEFORE]: twitterDeleteAllPosts,
  [TwitterRecommendationKey.TWITTER_AI_OPT_OUT]: twitterAiOptOut,
  [TwitterRecommendationKey.TWITTER_BLOCK_REPOSTERS]: twitterBlockReposters,
  [TwitterRecommendationKey.TWITTER_LEAVE_DIRECT_MESSAGES]:
    twitterDeleteConversations,
  [TwitterRecommendationKey.TWITTER_REMOVE_LIKES]: twitterDeleteLikes,
}

export const twitterRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => getAccountUsernameGatherStageDefs(),
  getAdditionalFullGatherStageDefs: () => getAdditionalFullGatherStageDefs(),
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
